import React from 'react'
import Style from './FJVipMark.module.less'
import FJVip from "./FJVip";
import FJLocalStore from "../../store/FJLocalStore";
import classNames from 'classnames'

function FJVipMark() {
  return (
    <div tooltip={FJLocalStore._('upgrade-to-edit-custom-watermark')}
         className={classNames(Style.container, 'u-tooltip-bottom')}>
      <FJVip id1='FJVipMark-1' id2='FJVipMark-2' />
    </div>
  );
}

export default FJVipMark;
